import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';
import { FOOTER } from '@/constants/testIds';

const Footer = () => {
  return (
    <footer data-testid={FOOTER.section} className="bg-navy border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center mb-6">
              <img
                src="/assets/img/viyaanwhite.png"
                alt="Jhaishna Technologies"
                className="h-10 w-auto"
              />
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Empowering businesses with innovative software solutions and Oracle consulting expertise since 2009.
            </p>
          </div>

          {/* Digital Services */}
          <div>
            <h4 className="font-heading text-sm font-bold text-white uppercase tracking-wider mb-6">Digital Services</h4>
            <ul className="space-y-3">
              {[
                { name: 'Oracle Communication Consulting', path: '/services#oracle' },
                { name: 'Tailored Billing Platform', path: '/services#billing' },
                { name: 'Tailored CRM System', path: '/services#crm' },
                { name: 'Digital Business Transformation', path: '/services#digital' },
                { name: 'Cloud Migration & Automation', path: '/services#cloud' },
                { name: 'Staff Augmentation', path: '/services#staff' },
              ].map((item) => (
                <li key={item.name}>
                  <Link to={item.path} className="text-sm text-slate-400 hover:text-amber transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-heading text-sm font-bold text-white uppercase tracking-wider mb-6">Products</h4>
            <ul className="space-y-3">
              {[
                { name: 'MXCloud', path: '/products#mxcloud' },
                { name: 'Loan Management System', path: '/products#lms' },
                { name: 'E-Invoicing Software', path: '/products#invoicing' },
                { name: 'HRMS', path: '/products#hrms' },
                { name: 'Fiber Optics', path: '/products#optics' },
              ].map((item) => (
                <li key={item.name}>
                  <Link to={item.path} className="text-sm text-slate-400 hover:text-amber transition-colors">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-heading text-sm font-bold text-white uppercase tracking-wider mb-6">Connect With Us</h4>
            <ul className="space-y-3">
              <li>
                <a data-testid={FOOTER.email} href="mailto:Info@jhaishna.com" className="text-sm text-slate-400 hover:text-amber transition-colors">
                  Work: Info@jhaishna.com
                </a>
              </li>
              <li>
                <a href="mailto:hr@jhaishna.com" className="text-sm text-slate-400 hover:text-amber transition-colors">
                  Jobs: hr@jhaishna.com
                </a>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-6">
              <a
                data-testid={FOOTER.twitter}
                href="https://x.com/JhaishnaTech"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-sm bg-surface border border-white/10 flex items-center justify-center text-slate-400 hover:text-amber hover:border-amber transition-all"
              >
                <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a
                data-testid={FOOTER.linkedin}
                href="https://www.linkedin.com/company/jhaishna/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-sm bg-surface border border-white/10 flex items-center justify-center text-slate-400 hover:text-amber hover:border-amber transition-all"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            Copyrights &copy; {new Date().getFullYear()}. All rights reserved by{' '}
            <Link to="/" className="text-amber hover:underline">Jhaishna Technologies</Link>
          </p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-sm text-slate-500 hover:text-slate-300 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-sm text-slate-500 hover:text-slate-300 transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
